import { render, staticRenderFns } from "./SignSeal.vue?vue&type=template&id=24330986&scoped=true&"
import script from "./SignSeal.vue?vue&type=script&lang=js&"
export * from "./SignSeal.vue?vue&type=script&lang=js&"
import style0 from "./SignSeal.vue?vue&type=style&index=0&id=24330986&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24330986",
  null
  
)

export default component.exports